import { isBrowser as g } from "@smh/utils/is-in-browser";
import { capitalize as L } from "@smh/utils/strings";
import { requestIdleCallback as P } from "@smh/utils/request-idle-callback";
const m = {
  webvisor: !1,
  clickmap: !0,
  trackLinks: !0,
  accurateTrackBounce: !0,
  trackHash: !0
}, x = () => `
  (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
  m[i].l=1*new Date();
  for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
  k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
  (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");`, Z = (e) => `<script async src="//x01.aidata.io/pixel.js?pixel=${e}&v=${Date.now()}"><\/script>`, ee = (e) => `<script>window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date; ga("create","${e}","auto"); ga("set", "transport", "beacon");<\/script><script async src="https://www.google-analytics.com/analytics.js"><\/script>`, te = (e) => `<script async src="https://www.googletagmanager.com/gtag/js?id=${e}"><\/script><script>  window.dataLayer = window.dataLayer || [];  function gtag(){dataLayer.push(arguments);}  gtag('js', new Date());  gtag('config', '${e}');<\/script>`, ne = (e) => `<script type="text/javascript">var _tmr = window._tmr || (window._tmr = []);_tmr.push({id: "${e}", type: "pageView", start: (new Date()).getTime()});(function (d, w, id) {if (d.getElementById(id)) return;var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;ts.src = "https://top-fwz1.mail.ru/js/code.js";var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }})(document, window, "topmailru-code");<\/script>`, oe = (e) => `<noscript><div><img src="https://top-fwz1.mail.ru/counter?id=${e};js=na" style="border:0;position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div></noscript>`, ie = (e, t = {}) => {
  const n = { ...m, ...t }, o = e.map((s) => typeof s == "number" ? {
    id: s,
    config: n
  } : {
    id: s.id,
    config: { ...n, ...s.config }
  });
  return `<script>
    ${x()}
    ${o.reduce((s, r) => s + `ym(${r.id}, "init", ${JSON.stringify({
    ...m,
    ...r.config
  })});`, "")}
    <\/script>
    ${o.reduce((s, r) => s + `<noscript><div><img src="https://mc.yandex.ru/watch/${r.id}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`, "")}
    `;
}, se = (e) => {
  const t = Object.keys(e);
  if (!(t.length > 0))
    return "";
  const o = t.reduce(
    (i, s) => (i[L(s)] = e[s], i),
    {}
  );
  return `
  <script>
    window.YandexRotorSettings = ${JSON.stringify(o)}
  <\/script>
  `;
}, re = (e) => `<script src="https://cdn.onthe.io/io.js/${e}"><\/script>`, ce = (e) => `<!--LiveInternet counter--><script> new Image().src = "https://counter.yadro.ru/hit;${e}?r"+ escape(document.referrer)+((typeof(screen)=="undefined")?"": ";s"+screen.width+"*"+screen.height+"*"+(screen.colorDepth? screen.colorDepth:screen.pixelDepth))+";u"+escape(document.URL)+ ";h"+escape(document.title.substring(0,150))+ ";"+Math.random();<\/script><!--/LiveInternet-->`, a = /* @__PURE__ */ new Map(), M = () => {
  window.ga = window.ga || function(...e) {
    var t;
    (window.ga.q = ((t = window.ga) == null ? void 0 : t.q) || []).push(e);
  }, window.ga.l = +new Date();
}, C = (e) => {
  if (g()) {
    M();
    const t = `t${a.size}`;
    window.ga !== void 0 && (window.ga("create", {
      trackingId: e,
      cookieDomain: "auto",
      name: t
    }), window.ga("set", "transport", "beacon"), a.set(e, t));
  }
}, w = (e, t, n) => {
  if (a.has(t) || C(t), g() && window.ga !== void 0) {
    const o = a.get(t);
    window.ga(`${o}.${e}`, n);
  }
}, h = (e, t) => {
  w("set", e, t);
}, _ = (e) => {
  w("send", e, "pageview");
}, y = (e, t) => {
  w("send", e, { hitType: "event", ...t });
}, ae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setGA: h,
  sendGAPageView: _,
  sendGaEvent: y
}, Symbol.toStringTag, { value: "Module" })), G = 80, D = (e) => `//counter.yadro.ru/${e}`, v = (e) => {
  const t = `${e}`, n = `r${escape(document.referrer)}`, o = `u${escape(document.URL)}`, i = `h${escape(document.title.substring(0, G))}`, s = `${Math.random()}`;
  let r = "";
  if (typeof screen < "u") {
    const O = screen.colorDepth ? screen.colorDepth : screen.pixelDepth;
    r = `;s${screen.width}*${screen.height}*${O}`;
  }
  return `${D(
    "hit"
  )};${t}?${n};${r};${o};${i};${s}`;
}, b = (e) => {
  new Image().src = v(e);
}, N = (e) => `(function () {new Image().src = ${v(e)}})();`, de = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sendHit: b,
  getLICounter: N
}, Symbol.toStringTag, { value: "Module" })), A = () => {
  window._tmr = window._tmr || (window._tmr = []);
}, $ = (e, t) => {
  window._tmr === void 0 && A(), window._tmr.push({ id: e, type: "pageView", url: t });
}, le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sendMailPageView: $
}, Symbol.toStringTag, { value: "Module" })), p = "0.2.0", U = () => {
  const e = "io";
  window.ioObject = e, window[e] = window[e] || function(...t) {
    (window[e].a = window[e].a || []).push(t);
  };
}, T = (e) => {
  window.ioObject === void 0 && U(), window.io !== void 0 && (window._io_config = window._io_config || {}, window._io_config[p] = window._io_config[p] || [], window._io_config[p].push(e));
}, pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sendOnTheIo: T
}, Symbol.toStringTag, { value: "Module" })), l = (...e) => {
  g() && window.ym !== void 0 && window.ym(...e);
}, S = (e, t, n) => {
  l(e, "hit", t, n);
}, E = (e, t) => {
  l(e, "userParams", t);
}, I = (e, t) => {
  l(e, "params", t);
}, j = (e, t, n) => {
  l(e, "reachGoal", t, n);
}, ue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sendYaHit: S,
  sendYaUserParams: E,
  sendYaParams: I,
  sendReachGoal: j
}, Symbol.toStringTag, { value: "Module" })), Y = (e, t) => {
  switch (e) {
    case "setPage": {
      const { trackers: n, options: o } = t;
      n.forEach((i) => {
        h(i, o);
      });
      break;
    }
    case "pageView": {
      const { trackers: n } = t;
      n.forEach((o) => {
        _(o);
      });
      break;
    }
    case "event": {
      const { trackers: n, options: o } = t;
      n.forEach((i) => {
        y(i, o);
      });
      break;
    }
  }
}, R = ({ counterId: e }) => {
  b(e);
}, z = ({ counterId: e, url: t }) => {
  $(e, t);
}, B = (e) => {
  const t = {
    config_page_url: e.configPageUrl,
    page_url: e.pageUrl,
    page_url_canonical: e.pageUrlCanonical,
    page_title: e.pageTitle,
    page_language: e.pageLanguage,
    page_type: e.pageType
  };
  return e.articleType && (t.article_type = e.articleType), e.articlePublicationDate && (t.article_publication_date = e.articlePublicationDate), e.articleCategories && (t.article_categories = e.articleCategories), e.articleAuthors && (t.article_authors = e.articleAuthors), {
    data: t
  };
}, V = (e) => {
  const { data: t } = B(e);
  T(t);
}, q = (e, t) => {
  switch (e) {
    case "hit": {
      const { counters: n, url: o, params: i } = t;
      n.forEach((s) => {
        S(s, o, i);
      });
      break;
    }
    case "reachGoal": {
      const { counters: n, goalName: o, params: i } = t;
      n.forEach((s) => {
        j(s, o, i);
      });
      break;
    }
    case "userParams": {
      const { counters: n, params: o } = t;
      n.forEach((i) => {
        E(i, o);
      });
      break;
    }
    case "params": {
      const { counters: n, params: o } = t;
      n.forEach((i) => {
        I(i, o);
      });
      break;
    }
  }
}, H = 500, d = [], J = (e) => {
  d.push(e), k();
}, f = () => d.length > 0;
let u = !1;
const k = () => {
  u || (u = !0, P(K, {
    timeout: H
  }));
}, Q = (e) => {
  if (e.metric === "yandex") {
    const { eventName: t, args: n } = e;
    q(t, n);
  }
  if (e.metric === "google") {
    const { eventName: t, args: n } = e;
    Y(t, n);
  }
  if (e.metric === "onTheIo") {
    const { args: t } = e;
    V(t);
  }
  if (e.metric === "mail") {
    const { args: t } = e;
    z(t);
  }
  if (e.metric === "live-internet") {
    const { args: t } = e;
    R(t);
  }
}, K = (e) => {
  for (u = !1; e.timeRemaining() > 0 && f(); ) {
    const [t] = d;
    Q(t), d.shift();
  }
  f() && k();
};
function c(e, t, n) {
  J({
    metric: e,
    eventName: t,
    args: n
  });
}
function ge(e, t) {
  c("yandex", e, t);
}
function we(e, t) {
  c("google", e, t);
}
function me(e, t) {
  c("onTheIo", e, t);
}
function fe(e, t) {
  c("mail", e, t);
}
function he(e, t) {
  c("live-internet", e, t);
}
function _e(e, t) {
  c("aidata", e, t);
}
export {
  ae as GoogleAnalyticsService,
  de as LiveInternetService,
  le as MailService,
  pe as OnTheIoService,
  ue as YandexMetricsService,
  Z as getAidataPixel,
  te as getGA4Counter,
  ee as getGoogleCounter,
  ce as getLiveInternetCounter,
  ne as getMailCounters,
  oe as getNoScriptMailCounter,
  re as getOnTheIoCounter,
  ie as getYandexCounters,
  se as getYandexRotorSettings,
  _e as sendAidata,
  we as sendGA,
  he as sendLI,
  fe as sendMA,
  me as sendOTI,
  ge as sendYM
};
